import { useEffect } from "react";
import "@/App.css";

const SITE = "/swipeupcar/v3/index.html";

function App() {
  useEffect(() => {
    window.location.replace(SITE);
  }, []);

  return (
    <div className="App" data-testid="redirect-home">
      <p style={{ fontFamily: "system-ui", padding: 24 }}>
        Redirection vers SWIPEUPCAR… <a href={SITE}>Cliquez ici</a> si rien ne se passe.
      </p>
    </div>
  );
}

export default App;
